








































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { RichiestaTirEstivi } from "../../_models/richiestaTirEstivi";

@Component
export default class DetailsRichiestaTirEstivi extends Vue {
  @Prop() info!: RichiestaTirEstivi;
}
